import React from "react";

type Option<T extends string> = { value: T; label: string };

type EcoSegmentedProps<T extends string> = {
  label: string;
  options: Option<T>[];
  value: T;
  onChange: (value: T) => void;
  disabled?: boolean;
  className?: string;
};

/** Grupo de botões exclusivos (`aria-pressed`) — o "Ativas / Desativadas" do design. */
function EcoSegmented<T extends string>({
  label,
  options,
  value,
  onChange,
  disabled,
  className,
}: EcoSegmentedProps<T>) {
  return (
    <div className={`ecoSegmented${className ? ` ${className}` : ""}`} role="group" aria-label={label}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`ecoSegmented__option${opt.value === value ? " is-selected" : ""}`}
          aria-pressed={opt.value === value}
          onClick={() => opt.value !== value && onChange(opt.value)}
          disabled={disabled}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default EcoSegmented;
